<div class="add-image-container" tabindex="-1" style="border:none;outline:none;" tabindex="=-1">
    <div class="dwform" >

        <div class="dwform-cell" >

            <div class="dwform-row-gap"></div>
              <div class="dwform-row">
                    <label class="label-field">Image Type:</label>
                    <span class="form-required">*</span>
                   <mat-select
                    disableOptionCentering placeholder="- Please Select -"
                    [(value)]="selectedImageType" #cbStatus floatLabel="never"
                    style="font-size: 10pt;width: 180px;"
                    panelClass="local-drop-down-panel" class="dw-mat-select"
                    (selectionChange)="onChangeImageType($event)">
                    <mat-option	value='Container'>Container</mat-option>
                    <mat-option value='Dose'>Dose</mat-option>
                </mat-select>
            </div>
            
          <div class="dwform-row-double-gap"></div>

            <div class="dwform-row" style="width:100%; height:100px;padding-bottom: 5px;">
              <mat-tab-group style="width:100%;" >
                  <mat-tab label="Paste Image">
                      <app-paste-selector (onPasteSelected)="onPasteSelectedHandler($event)">

                      </app-paste-selector>
                  </mat-tab>
                  <mat-tab label="Upload File">
                      <app-file-selector
                              [file_types]="'PNG, JPG, JPEG, GIF'" [header]="'Upload your images'"
                              (onFileSelected)="onFileSelectedHandler($event)">
                      </app-file-selector>
                  </mat-tab>
              </mat-tab-group>

            </div>
            <div style="text-align: center;margin-top: 5px; overflow-y: auto; height: 80px;">
                <img *ngIf="previewSRC" style="max-width: 380px; " id="preview" [src]="previewSRC"  alt="preview" />
            </div>


            <!----------------------->
            <!-- ERROR LINE --------->
            <!----------------------->
            <div class="error-line" [hidden]='!strErr.length'
                 style="text-align:left; bottom:47px; margin-left: 13px">{{strErr}}</div>
            <!----------------------->
            <!-- SAVE STRIP        -->
            <!----------------------->
            <div class="save-close-strip" style="bottom: 10px;">

                <button mat-button class="command-button"
                        (click)="doSubmit()" matTooltip="Submit / save this entry"
                        mat-button>
                    <mat-icon>check_circle_outline</mat-icon>
                    Submit
                </button>
                <button mat-button class="command-button"
                        (click)="doCancel()" matTooltip="Cancel without saving this entry" mat-button>
                    <mat-icon>highlight_off</mat-icon>
                    Cancel
                </button>
            </div>
    </div>
</div>
</div>
